<template>
  <vc-fragment>
    <slot
      :onNext="onNext"
      :disabledNext="disabledNext"
      :onPrevious="onPrevious"
      :disabledPrev="disabledPrev"
      :total="moreStocks.length"
      :current="currentIndex + 1"
      :onClose="onClose"
      :onRefresh="onRefresh"
      />
  </vc-fragment>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'
import { ServiceStocks } from '@/services/Stocks'
import Fragment from '@/components/fragment'

export default {
  name: 'StockEditorWrapper',
  components: {
    'vc-fragment': Fragment
  },
  mixins: [routeEditLogic],
  props: {
    editorId: { type: String, required: true },
    config: {
      type: Object,
      default: () => ({
        id: 'open-id'
      })
    }
  },
  created () {
    this.$bus.$on('Refresh-Grid', this.proxyRefresh)
    this.$bus.$on(`Call-Grid-Delete-${this.editorId}`, this.proxyDelete)
    this.$bus.$on(`Call-Grid-Create-${this.editorId}`, this.proxyCreate)
    this.$bus.$on(`Call-Grid-Patch-${this.editorId}`, this.proxyPatch)
  },
  beforeDestroy () {
    this.$bus.$off('Refresh-Grid', this.proxyRefresh)
    this.$bus.$off(`Call-Grid-Delete-${this.editorId}`, this.proxyDelete)
    this.$bus.$off(`Call-Grid-Create-${this.editorId}`, this.proxyCreate)
    this.$bus.$off(`Call-Grid-Patch-${this.editorId}`, this.proxyPatch)
  },
  computed: {
    disabledPrev () {
      return this.currentIndex <= 0
    },
    disabledNext () {
      return this.currentIndex >= (this.moreStocks.length - 1)
    }
  },
  data () {
    return {
      moreStocks: [],
      currentIndex: 0
    }
  },
  methods: {
    onPrevious () {
      const newIndex = this.currentIndex - 1
      this.onChangeValue(newIndex)
    },
    onNext () {
      const newIndex = this.currentIndex + 1
      this.onChangeValue(newIndex)
    },
    onChangeValue (index) {
      const item = this.moreStocks[index]
      if (item) {
        this.mixSetRoute({ value: item.id, state: 'edit', id: this.editorId })
        this.currentIndex = index
      }
    },
    onClose () {
      this.mixSetRoute()
    },
    onRefresh () {
      return this.loadStocks({ value: this.mixValue, state: this.mixState })
    },

    async loadStocks ({ value, state }) {
      try {
        const moreStocks = await ServiceStocks.getStocksWithTheSamePart({ id: value })
        this.moreStocks = [{ id: value }, ...moreStocks]
        this.setEditorItem({ state })
      } catch (e) {
        this.requestErrorHandler(e)
      }
    },
    async mixHookState ({ value, state }) {
      if (state === 'edit') {
        return this.loadStocks({ value, state })
      }
    },
    setEditorItem ({ state }) {
      const stateValue = this.mixGetRouteStateValue(this.editorId)
      const editorValue = Number((stateValue && stateValue.value) || this.mixValue)

      const itemIndex = this.moreStocks.findIndex(({ id }) => id === editorValue)

      const item = itemIndex === -1 ? this.moreStocks[0] : this.moreStocks[itemIndex]

      const value = item && item.id

      if (value) {
        this.mixSetRoute({ value, state, id: this.editorId })
      } else {
        this.mixSetRoute({ id: this.editorId })
        this.mixSetRoute()
        this.$notify.error({
          title: 'Error',
          message: `${this.L10n('incorrect-query-string')}`,
          position: 'bottom-right'
        })
      }

      this.currentIndex = itemIndex === -1 ? 0 : itemIndex
    },
    mixHookReset () {
      this.moreStocks = []
      this.currentIndex = 0
    },
    mixHookNew () {
      this.mixSetRoute({ state: 'new', id: this.editorId })
    },

    // PROXY EVENTS
    proxyRefresh ({ id }) {
      if (id === this.editorId) {
        this.$bus.$emit('Refresh-Grid', { id: this.config.id })
      }
    },
    proxyDelete (...args) {
      this.$bus.$emit(`Call-Grid-Delete-${this.config.id}`, ...args)
    },
    proxyCreate (...args) {
      this.$bus.$emit(`Call-Grid-Create-${this.config.id}`, ...args)
    },
    proxyPatch (...args) {
      this.$bus.$emit(`Call-Grid-Patch-${this.config.id}`, ...args)
    }
  }
}
</script>
